export class SiteHeaderMenu {
  constructor() {
    this.header = document.querySelector('.js-site-header-nav');
    this.header_menu = document.querySelector('.js-site-header-nav-wrapper');
    this.header_nav = document.querySelector('nav#site-menu');
    this.sticky_header = this.header.dataset.headerMenuType;
    this.is_sticky_header = (this.sticky_header === 'true');
    this.last_depth = 0;

    this.header_menu_elements = this.header_menu?.querySelectorAll('.js-header-menu a[href*="#"]') ?? [];
    this.header_menu_elements_offsets = [];
    this.header_elements_with_scroll_variant = this.header?.querySelectorAll('.js-on-scroll') ?? [];
    this.stopScrollSpy = false;
    this.subscribers = [];
    this.padding_for_sibling = (this.header?.dataset?.headerNextSiblingPadding) ? this.header.dataset.headerNextSiblingPadding : false;


    this.getElementMenuOffsets();
    //console.log(this.header_menu_elements_offsets);
    this.addListener();
    this.stickySiblingElementPaddingTop(this.padding_for_sibling);
  }

  addListener() {
    this.header_menu_elements.forEach(elem => {
      elem.addEventListener('click', (e) => {
        this.stopScrollSpy = true;

        if (!elem.hash) {
          return;
        }

        let target = document.querySelector(elem.hash);

        if (!target) {

          // remove hasf from target string
          const target_id = elem.hash.replace('#', '');
          target = document.querySelector('[data-target-id="' + target_id + '"]');
        }

        if (!target) {
          return;
        }

        // smoot scroll to target

        e.preventDefault();
        const target_offset = target.offsetTop;
        const header_h = this.header.innerHeight || this.header.clientHeight;
        const target_offset_top = target_offset - header_h;

        window.focus();
        window.scrollTo({
          top: target_offset_top,
          behavior: 'smooth',
        });


        this.toogleActiveMenuElement(elem);
        this.toogleMobileMenu();

        setTimeout(() => {
          this.stopScrollSpy = false;
        }, 500);

      })
    });
  }

  subscribe(subscriber) {
    this.subscribers.push(subscriber);
    //console.log("-> this.subscribers", this.subscribers);
  }

  toogleActiveMenuElement(event_elem, force_remove_active = false) {

    if (force_remove_active) {
      event_elem.parentNode.classList.remove('active');
      return;
    }

    this.header_menu_elements.forEach(elem => {
      elem.parentNode.classList.remove('active');
    })

    event_elem.parentNode.classList.add('active');
  }

  toogleMobileMenu() {
    if (!this.header || !this.header_menu) {
      return false;
    }

    // only in window is less than 992

    if (window.innerWidth > 992) {
      return;
    }


    let open = false;

    if (this.header_menu.classList.contains('active')) {
      this.header_menu.classList.remove('active');
      this.header_nav.classList.remove('active');
      this.header.classList.remove('menu-is-open');
      open = false;
      this.toggleBlockBody(open);
      return;
    }

    const header_menu_h = this.header_menu.scrollHeight;
    const header_h = this.header.innerHeight || this.header.clientHeight;

    let w = window,
      d = document,
      e = d.documentElement,
      g = d.getElementsByTagName('body')[0],
      x = w.innerWidth || e.clientWidth || g.clientWidth,
      y = w.innerHeight || e.clientHeight || g.clientHeight;

    this.header_menu.style.top = header_h + 'px';
    this.header_menu.style.height = 'calc(100vh - ' + header_h + 'px)';

    if (header_menu_h > (y + 200)) {
      this.header_menu.classList.add('justify-start', 'overflow-y-scroll', 'sm:overflow-y-visible');
    } else {
      this.header_menu.classList.remove('justify-start');
      this.header_menu.classList.remove('overflow-y-scroll');
      this.header_menu.classList.remove('sm:overflow-y-visible');
    }

    this.header_menu.classList.toggle('active');
    this.header_nav.classList.toggle('active');
    this.header.classList.toggle('menu-is-open');
    open = true;


    this.toggleBlockBody(open);
  }

  toggleBlockBody(open) {

    if (open) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }

  }

  stickySiblingElementPaddingTop() {
    if (!this.is_sticky_header || !this.padding_for_sibling) {
      return false;
    }

    let sibling = this.header.nextElementSibling;

    if (!sibling) {
      return false;
    }

    let tag = sibling.tagName.toLowerCase();

    if (tag == 'main') {
      sibling = sibling.firstElementChild;
    }

    if (!sibling) {
      return false;
    }

    const sibling_styles = getComputedStyle(sibling);
    const sibling_paddingTop = parseInt(sibling_styles.paddingTop);
    const header_h = this.header.innerHeight || this.header.clientHeight;

    if (header_h > sibling_paddingTop) {
      sibling.style.paddingTop = ((header_h + 20) / 16) + 'rem';
    }


  }

  onScroll(depth) {
    this.stickyMenu(depth);
    this.changeElementsSizeByScroll(depth)
    this.scrollSpyCurrentMenuElement(depth);
  }

  changeElementsSizeByScroll(depth) {
    this.header_elements_with_scroll_variant.forEach((e) => {
      if (depth > 300) {
        e.classList.add('is-scrolled');
      } else {
        e.classList.remove('is-scrolled');
      }
    })
  }

  stickyMenu(depth) {

    if (!this.is_sticky_header) {
      return false;
    }

    if (depth > 40) {
      this.header.classList.add('is-scrolled');
      this.header.classList.add('is-visible');
      this.header.classList.remove('is-hidden');

    } else {
      this.header.classList.add('is-hidden');
      this.header.classList.remove('is-scrolled');
      this.header.classList.remove('is-visible');
    }

    this.last_depth = depth;
  }

  getElementMenuOffsets() {
    this.header_menu_elements.forEach((elem) => {

      if (!elem.hash) {
        return;
      }

      let target = document.querySelector(elem.hash);

      if (!target) {

        // remove hasf from target string
        const target_id = elem.hash.replace('#', '');
        target = document.querySelector('[data-target-id="' + target_id + '"]');
      }

      if (!target) {
        return;
      }

      const target_position = target.offsetTop - 100;
      const target_height = target.scrollHeight;
      const target_end = target_position + target_height;

      let offset = {
        'start': target_position,
        'stop': target_end,
        'target': target,
        'element': elem
      };

      this.header_menu_elements_offsets.push(offset);
    })
  }

  scrollSpyCurrentMenuElement(depth) {

    if (this.stopScrollSpy) {
      return;
    }


    this.header_menu_elements_offsets.forEach((spy_object) => {
      if (depth > spy_object['start'] && depth < spy_object['stop']) {
        this.toogleActiveMenuElement(spy_object['element']);
      } else {
        this.toogleActiveMenuElement(spy_object['element'], true);
      }
    })

  }

  setDarkTheme() {
    this.header.classList.add('is-dark');
  }

  removeDarkTheme() {
    this.header.classList.remove('is-dark');
  }
}
